import React from 'react'
import logo from '../../../assets/appLogo.png'
import { useNavigate } from 'react-router-dom'

const Header = () => {
  const navigate=useNavigate()
  return (
    <div className='login-header'>
        <img src={logo} alt='app-logo-login' style={{cursor:"pointer"}}onClick={()=>navigate('/')}/>
        <p className="login-header-desc">
        Don't have an account? <span 
          style={{ color: "rgba(26, 76, 255, 1)", fontWeight: "600", cursor: "pointer" }}
          onClick={() => navigate("/get-started")}
        >Get Started for free</span>
      </p>
    </div>
  )
}

export default Header